import { StyledSearch, StyledSearchContainer } from "./index.styled";
import { useIntl } from "react-intl";

type Props = {
  handleSearch: (value: string) => void;
};

export default function SearchBar({ handleSearch }: Props) {
  const { messages } = useIntl();

  return (
    <StyledSearchContainer>
      <StyledSearch
        placeholder={messages["common.search"] as string}
        allowClear
        enterButton
        size="middle"
        onChange={(e) => handleSearch(e.target.value)}
      />
    </StyledSearchContainer>
  );
}
